import { brlMask } from '../../helpers/masks';

export default function Cart({ cart, amount, t }) {
  return (
    <>
      <h2 className='site-title mb-3'>{t('tickets.fields.summary')}</h2>
      <ul className='order-summary mb-3'>
        {cart.map((ticket) => (
          <li key={ticket.id}>
            <div>
              <div className='fw-semibold'>{ticket.description}</div>
              <small className='text-body-secondary'>
                {ticket.count} x {brlMask(ticket.price)}
              </small>
            </div>
            <span className='text-body-secondary'>
              {brlMask(Math.round(ticket.count * ticket.price * 100) / 100)}
            </span>
          </li>
        ))}
        {amount !== null && (
          <li className='order-summary__total'>
            <span>Total</span>
            <strong>{brlMask(amount)}</strong>
          </li>
        )}
      </ul>
    </>
  );
}
